import React from 'react';

import CSSModules from 'react-css-modules';

import {CrossIcon, TickIcon} from '../../../../icons';
import Text from '../../../../TextComponents/Text';

import styles from './styles.module.scss';

type AnswerType = {
  text: string;
  solution: boolean;
  isSelected?: boolean;
};

export type OnSelectAnswer = (
  answerIndex: number,
  solution: boolean,
  isSelected?: boolean
) => void;

export type OnUnselectAnswer = (answerIndex: number) => void;

type AnswerProps = {
  answer: AnswerType;
  isAssessment: boolean;
  multipleChoice: boolean;
  answerIndex: number;
  onSelectAnswer?: OnSelectAnswer;
  onUnselectAnswer?: OnUnselectAnswer;
  disabled?: boolean;
  reskinClassName?: string;
  isPreview?: boolean;
  accessibilityLabels: {
    icon: {
      correct: string;
      incorrect: string;
    };
  };
};

// eslint-disable-next-line complexity
const Answer = ({
  answer,
  answerIndex,
  disabled,
  multipleChoice,
  onSelectAnswer,
  onUnselectAnswer,
  isAssessment,
  reskinClassName,
  isPreview,
  accessibilityLabels,
}: AnswerProps): JSX.Element => {
  const {text, solution, isSelected} = answer;

  const onClick = () => {
    if (isSelected && onUnselectAnswer) {
      onUnselectAnswer(answerIndex);
    } else if (onSelectAnswer) {
      onSelectAnswer(answerIndex, solution, isSelected);
    }
  };

  const selectedInLesson = isSelected && !isAssessment;

  let className = 'answer';
  if (!multipleChoice) {
    className += ' single-choice';
  }
  if (selectedInLesson) {
    className += solution ? ' correct' : ' incorrect';
  }
  if (isSelected && isAssessment) {
    className += ' selected';
  }
  if (reskinClassName) {
    className += ` ${reskinClassName}`;
  }
  if (isPreview) {
    className += ' preview-mode';
  }

  return (
    <button
      styleName={className}
      onClick={onClick}
      type='button'
      disabled={selectedInLesson || disabled}
    >
      <div>
        {multipleChoice && <div styleName='checkbox' />}
        <Text
          size='m'
          weight='medium'
          dataAutomation={`quiz-answer${isPreview ? '-thumbnail' : ''}`}
        >
          {text}
        </Text>
      </div>
      {selectedInLesson &&
        (solution ? (
          <TickIcon
            size='tiny'
            colour='green'
            alt={accessibilityLabels.icon.correct}
          />
        ) : (
          <CrossIcon
            size='tiny'
            colour='red'
            alt={accessibilityLabels.icon.incorrect}
          />
        ))}
    </button>
  );
};

export default CSSModules(Answer, styles, {allowMultiple: true});
